<template>
  <div class="informacoes" v-if="modules.length && module">
    <div class="container" style="max-width: 860px; margin: 0 auto;" v-if="user.course">

      <div class="title-module">
        <div class="prev-name" v-if="module.order > 1" @click="prevModule()">
          <v-icon style="color: #3f6696; cursor: pointer;">fas fa-chevron-left</v-icon>
        </div>
        <div class="name">
          {{module.name}}
        </div>
        <div class="next-name" v-if="_isNext()" @click="nextModule()">
          <v-icon style="color: #3f6696; cursor: pointer;">fas fa-chevron-right</v-icon>
        </div>
      </div>

      <div v-for="(lesson, i) in module['lessons']" :key="i">
        <div class="lesson-item" style="width: 100%; float: left;">
          <div class="lessons-check">
            <div v-if="isDone(lesson)">
              <div class="check">
                <v-icon>far fa-check-square</v-icon>
                <h4>Feito</h4>
              </div>
            </div>

            <div class="title">
              <div class="aula">
                {{lesson.name}}
                <br />
                <span
                  v-if="isLock(lesson)"
                  class="aula-time"
                >Disponível em {{_unlockedTime(lesson)}}</span>
                <span v-if="isDone(lesson)" class="aula-time">Nota {{_calcNota(lesson)}}</span>
              </div>

              <div style="float:right;" v-if="isLock(lesson)">
                <v-icon style="color:#FFF">fas fa-lock</v-icon>
              </div>

              <div class="action" v-else>
                <div class="btn-in">
                  <router-link
                    :to="{ name: 'lesson', params: { module: lesson.module_id, id: lesson.id }}"
                  >Entrar</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style="width: 100%; float: left;"
          class="training-item"
          v-if="_checkTraining(lesson, i)"
        >
          <list-training></list-training>
        </div>

        <div style="width: 100%; float: left;">
          <list-conversation :conversation="_getConversation(lesson)" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { authService } from "../plugins/firebase";
import moment from "moment";
export default {
  data() {
    return {
      modules: [],
      module: null,
      activities: null,
      conversations: null,
      user: {}
    };
  },
  mounted() {
    this.getRemoteData();
  },
  methods: {
    isDone(lesson) {
      if (this.user.course.module.order > this.module["order"]) {
        return true;
      }

      return this.user.course.lesson.order > lesson["order"];
    },
    isLock(lesson) {
      if (
        lesson["order"] > this.user.course.unlocked &&
        this.user.course.module.order <= this.module["order"]
      ) {
        return true;
      }

      return false;
    },
    _unlockedTime(lesson) {
      var started = moment(this.user.course.started).add(
        lesson["release"],
        "days"
      );
      return started.format("DD/MM/YYYY");
    },
    _calcNota(lesson) {
      if (!this.activities) return "";
      let totalLesson = 0;
      let nota = 10 / lesson["questions"].length;
      console.log("_calcNota: " + nota);
      //List<dynamic> _activities = activitiesBloc.getValue();
      //print(_activities.length.toString() + ' |||| ' + lesson['questions'].length.toString());
      lesson["questions"].forEach(q => {
        let _activity = this.activities.find(o => o["question_id"] == q["id"]);

        if (_activity != null && _activity["status"] == "hit") {
          totalLesson += nota;
        }
      });

      let res = totalLesson.toFixed(1) + "";
      return res.replace(".0", "");
    },
    _isNext() {
      let mod = this.modules.find(
        o =>
          o["order"] == this.module["order"] + 1 &&
          o["order"] <= this.user.course.module.order
      );

      return mod != null;
    },
    _checkTraining(lesson, i) {
      if (
        (this.isDone(lesson) && i == this.module["lessons"].length - 1) ||
        (this.isDone(lesson) && !this.isDone(this.module["lessons"][i + 1]))
      ) {
        return true;
      }
      return false;
    },
    _getConversation(lesson) {
      if (!this.conversations || !this.isDone(lesson)) return null;
      return this.conversations.find(
        a =>
          a["lesson_order"] == lesson["order"] &&
          a["module_order"] == this.module["order"]
      );
    },
    prevModule() {
      let mod = this.modules.find(o => o["order"] == this.module["order"] - 1);

      if (mod != null) {
        this.module = mod;
      }
    },
    nextModule() {
      var mod = this.modules.find(o => o["order"] == this.module["order"] + 1);

      if (mod != null) {
        this.module = mod;
      }
    },
    getConversations(config) {
      return this.$http
        .get(SERVE+"/students/conversations", config)
        .then(response => {
          this.conversations = response.data;
          CONVERSATION = response.data;
        });
    },
    getActivities(config) {
      return this.$http
        .get(SERVE+"/students/myactivities", config)
        .then(response => {
          ACTIVITIES = response.data;
          this.activities = ACTIVITIES;
        });
    },
    getModules(config) {
      return this.$http
        .get(SERVE+"/students/modules", config)
        .then(response => {
          MODULES = response.data;
          this.modules = response.data;

          const arr = [];

          MODULES.forEach(obj => {
            if (obj["id"] == this.user.course["module_id"]) {
              this.module = obj;
            }
          });
        });
    },
    getUser(config) {
      return this.$http
        .get(
          this.$SERVE + "/students/me?device_id=" +
            DeviceUUID.get() +
            "&device_name="+DeviceUUID.parse().browser+"&platform=web",
          config
        )
        .then(response => {
          USER = response.data;
          this.user = USER;
        });
    },
    async getRemoteData() {
      let config = {
        headers: {
          Authorization: "Bearer " + (await authService.validToken())
        }
      };

      console.log("USER", USER);

      if (USER) {
        this.user = USER;
      } else {
        await this.getUser(config);
      }

      if (MODULES) {
        this.modules = MODULES;
        MODULES.forEach(obj => {
          if (obj["id"] == this.user.course["module_id"]) {
            this.module = obj;
          }
        });
      } else {
        await this.getModules(config);
      }

      if (CONVERSATION) {
        this.conversations = CONVERSATION;
      } else {
        await this.getConversations(config);
      }

      if (ACTIVITIES) {
        this.activities = ACTIVITIES;
      } else {
        await this.getActivities(config);
      }
    }
  }
};
</script>

